import { render, staticRenderFns } from "./flex-setting.vue?vue&type=template&id=06dd3436&scoped=true"
import script from "./flex-setting.vue?vue&type=script&lang=js"
export * from "./flex-setting.vue?vue&type=script&lang=js"
import style0 from "./flex-setting.vue?vue&type=style&index=0&id=06dd3436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd3436",
  null
  
)

export default component.exports